module.exports = __webpack_public_path__ + "static/media/img-contact-placeholder.6988f7c9.svg";